<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="open()"
      >添加国家码</el-button
    >

    <el-dialog
      title="添加国家码"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="中文" prop="zh">
          <el-input
            v-model.trim="ruleForm.zh"
            placeholder="请输入国家名称(中文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文" prop="en">
          <el-input
            v-model.trim="ruleForm.en"
            placeholder="请输入国家名称(英文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家区号" prop="code">
          <el-input
            v-model.trim="ruleForm.code"
            placeholder="请输入国家区号，例如中国为86"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家码" prop="locale">
          <el-input
            v-model.trim="ruleForm.locale"
            placeholder="例如中国为CHN"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="ruleForm.status" ></el-input> -->

          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为选中，红色则为未选中"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定添加</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        zh: "",
        locale: "",
        code: "",
        en: "",
        status:true,
      },
      arr: [],
      result: false,
      rules: {
        zh: [
          { required: true, message: "请输入国家名称（中文）", trigger: "blur" },
          // { min: 2, max: 8, message: "长度在 2 到 8 个字符", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入国家区号", trigger: "blur" },
          // { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        en: [
          { required: true, message:'请输入国家名称（英文）', trigger: "blur" },
          
        ],
        locale: [
          { required: true, message: "请输入国家码", trigger: "blur" },
          // { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
      },
      // rules: {
      //   zh: [
      //     {
      //       required: true,
      //       validator: ValidateZH,
      //       trigger: "blur",
      //     },
      //     {
      //       min: 2,
      //       max: 30,
      //       message: "长度在 2 到 30 个字符",
      //       trigger: "blur",
      //     },
      //   ],
      //   status:[{required:true}],
      //   en: [
      //     { required: true, validator: ValidateEN, trigger: "blur" },
      //     {
      //       min: 2,
      //       max: 30,
      //       message: "长度在 2 到 30 个字符",
      //       trigger: "blur",
      //     },
      //   ],
      //   code: [
      //     {
      //       required: true,
      //       validator: ValidateCode,
      //       trigger: "blur",
      //     },
      //     { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" },
      //   ],
      //   locale: [
      //     {
      //       required: true,
      //       validator: ValidateLocale,
      //       trigger: "blur",
      //     },
      //     { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" },
      //   ],
      // },
    };
  },
  // mounted() {
  //   this.ruleForm = {
  //     zh: "",
  //     locale: "",
  //     code: "",
  //     en: "",
  //     status: false,
  //   };
  // },
  methods: {
    ...mapActions("countryCode", ["addOne", "getlist"]),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    closeDialog() {},
    open(){
      this.dialogVisible=true
    },
  submitForm(ruleForm) {
     
      this.$refs[ruleForm].validate(async (valid) => {
        if(valid){
          const res = await this.addOne({
            ...this.ruleForm,
            status: Number(this.ruleForm.status),
          });
          if (res.code == 0) {
              this.dialogVisible = false;
              this.getlist({page:1,size:25});
              this.ruleForm = {
                zh: "",
                locale: "",
                code: "",
                en: "",
                status: 0,
              };
              this.$message.success("添加成功");
        
          } 
          if(res.code==-1){
            this.ruleForm = {
                zh: "",
                locale: "",
                code: "",
                en: "",
                status: 0,
              };
              this.dialogVisible = false;
            this.$message.error(res.msg);
          
          }
        }

      })

    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    resetForm(formName) {
        this.$refs[formName].resetFields();
      }
  },
};
</script>

<style lang="less" scoped></style>
